module.exports = "<div class=\"card mt-3\">\n  <div class=\"cover\" *ngFor=\"let item of areas; let first = first; let last = last\" [routerLink]=\"['/technical', item?.id]\">\n    <img [src]=\"item?.image\" [ngClass]=\"(first ? 'border-top' : (last ? 'border-bottom' : 'border-center'))\" alt=\"\">\n    <div class=\"overlay\" [ngClass]=\"(first ? 'border-top' : (last ? 'border-bottom' : 'border-center'))\">\n      <!-- <h4>{{ item?.area }}</h4> -->\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/training-and-products/training-and-products.component.html
// module id = ./src/app/shared/training-and-products/training-and-products.component.html
// module chunks = main